function extractPart(value) {
  const int = parseInt(value, 10);

  if (isNaN(int)) {
    return 0;
  }

  return int;
}

class Version {
  constructor(major = 0, minor = 0, revision = 0, build = 0) {
    this.major = extractPart(major);
    this.minor = extractPart(minor);
    this.revision = extractPart(revision);
    this.build = extractPart(build);
  }

  static fromString(versionString) {
    const parts = versionString.split('.')
      .map(str => parseInt(str, 10));

    return new Version(...parts);
  }

  isEqualTo(other) {
    return this.getBuildValue() === other.getBuildValue();
  }

  isLessThan(other) {
    return this.getBuildValue() < other.getBuildValue();
  }

  isGreaterThan(other) {
    return this.getBuildValue() > other.getBuildValue();
  }

  getBuildValue() {
    // 5 digits of support
    const buildFactor = 100000;

    // 4 digits of support
    const revisionFactor = 10000 * buildFactor;

    // 3 digits of support;
    const minorFactor = 100 * revisionFactor;

    return (this.major * minorFactor) +
      (this.minor * revisionFactor) +
      (this.revision * buildFactor) +
      this.build;
  }

  toString() {
    return `${this.major}.${this.minor}.${this.revision}.${this.build}`;
  }
}

export default Version;



// WEBPACK FOOTER //
// ./V7/tnew/lib/Version.js